import {makeStyles, Typography} from "@material-ui/core";
import React from "react";
import {Grid} from "@material-ui/core";

const useInfoStyles = makeStyles(theme => ({
    root: {
        padding: '2%',
        whiteSpace: 'initial',
        display: 'inline-block',
        width: '100%',
        '& table tr td': {
            border: '1px solid #fff'
        },
        '& a': {
            color: '#fff'
        }
    }
}))
const PageTermeniSiConditii = () => {

    const classes = useInfoStyles();

    return <Grid item xs={12} className={classes.root}>
        <Typography variant="body2" color={"textSecondary"} display={"block"} component="div">
            <div className="sd-section">
                <div className="page-text">
                    <div className="fusion-text"><p>Acest site web a carui adresa este&nbsp;<a
                        href="https://www.cremosso.ro">www.cremosso.ro</a>&nbsp;(denumit
                        in continuare “ Website”) este detinut si operat de catre compania Danone Romania P.D.P.A si este
                        oferit in
                        scopuri educative, distractive si de informare. Va rugam sa cititi &nbsp;Conditiile de utilizare ale
                        site-ului WEB (denumite in continuare “conditiile de utilizare cu atentie inainte de utilizarea
                        acestui site
                        web.</p>
                        <p>Prin accesarea, cautarea in acest site sau simpla utilizare a site-ului, sau versiunea mobila a
                            acestuia,
                            dvs. agreati sa respectati aceste conditii de utilizare.&nbsp; &nbsp;Daca nu agreati conditiile
                            de utilizare
                            ale acestui site web sau politica referitoare la protectia informatiilor private, asa cum sunt
                            descrise mai
                            jos, va rugam sa nu utilizati acest site web.</p>
                        <p>Va rugam sa va intoarceti la site-ul web si sa revedeti conditiile de utilizare din cand in cand,
                            intrucat
                            acestea pot fi modificate de catre Danone, fara a va notifica personal. Orice modificari ale
                            acestor
                            conditii de utilizare vor fi aplicabile imediat ce modificarea respectiva este realizata pe
                            site.&nbsp;Daca
                            aceste conditii sau modificarile acestora nu sunt acceptabile pentru dvs., va rugam sa nu
                            utilizati site-ul
                            web.</p>
                        <p>Companie Danone Romania PDPA</p>
                        <p>Str. Soldat Nicolae Canea, nr 140 -1 60, Bucuresti, Sector 2, Bucuresti.</p>
                        <p><strong>&nbsp;</strong></p>
                        <h3>UTILIZAREA CONTINUTULUI SITE-ULUI WEB</h3>
                        <p>Prin accesarea acestui site web, in calitate de utilizator sau vizitator al site-ului, acceptati
                            sa folositi
                            site-ul in conformitate cu aceste conditii, in conformitate cu legile, clauzelor de inlaturare
                            a &nbsp;raspunderii,
                            politicii de protectie a datelor private si politicii de cookies (denumite in mod colectiv
                            conditiile).</p>
                        <p>Nu puteti folosi aceste site web pentru un scop nelegal sau care este interzis de aceste conditii
                            de
                            utilizare, sau de legislatie, norme morale, norme de ordine publica sau buna-credinta.</p>
                        <p>Nu puteti folosi paianjeni, roboti, tehnologii de minare a datelor sau alte dispozitive automate
                            ori programe
                            pentru a cataloga, descarca sau reproduce in orice fel, stoca ori distribui continutul expus pe
                            acest site.
                            In plus, nu puteti utiliza aceste dispozitive automate ca sa modificati site-ul ori sa incercati
                            sa depasiti
                            limitele de autoritate si acces care v-au fost conferite, in conformitate cu aceste
                            conditii.</p>
                        <p>Nu puteti utiliza site-ul web in orice alt mod care poate intrerupe, produce daune, il aduce in
                            stare de
                            neutilizare sau interfereaza cu orice utilizare a site-ului de catre alt utilizator, incluzand,
                            dar fara a
                            ne limita la supraincarcarea, inundarea, bombardarea cu mailuri ori spargerea site-ului sau
                            fortarea
                            limitelor de securitate ori a masurilor de autentificare a utilizatorilor.</p>
                        <p>Nu puteti incerca sa obtineti acces neautorizat la acest site, prin spargere, minarea parolelor
                            sau prin
                            orice alte mijloace.</p>
                        <p>NU puteti adauga portiuni din acest site intr-un alt site web si nici sa stabiliti legaturi catre
                            un alt site
                            si de asemenea, nu puteti sa stabiliti legaturi dintr-un alt site web catre alta pagina, alta
                            decat pagina
                            home.</p>
                        <p>Nu puteti vinde dreptul de utilizare sau acces catre site-ul web catre o terta parte.</p>
                        <p>Danone isi rezerva dreptul in mod unilateral, de a inceta sau suspenda accesul catre site, sau
                            catre o parte
                            din acesta, la orice moment, pentru orice motiv sau fara motiv, fara notificare prealabila
                            si/sau fara
                            notificare.</p>
                        <h3>COOKIES</h3>
                        <p>Acest site foloseste Cookies, care sunt reprezentate de portiuni scurte de text stocate in
                            computerul dvs. si
                            care sunt utile pentru administrarea si intretinerea site-ului.</p>
                        <p>Cateva date personale pot fi colectate de aceste cookies. Puteti afla mai multe despre modul in
                            care le
                            folosim si care date sunt colectate citind pe&nbsp;<a
                                href="http://www.danone.ro/wp-content/uploads/2014/04/COOKIES-POLICY.pdf">politica de
                                Cookies</a>.
                        </p>
                        <h3>DREPTURI DE PROPPRIETATE INTELECTUALA</h3>
                        <p>Continutul site-ului web reprezinta proprietatea sau a fost licentiat catre Danone si sunt
                            protejate de
                            legislatia referitoare la brevete, marci, dreptul de utilizare si alte legi. Cu exceptia
                            utilizarii in scop
                            personal sau non-comercial, nu este permisa reproducerea, transmiterea, distribuirea sau
                            afisarea acestor
                            materiale, fara consimtamantul scris al Danone.</p>
                        <p>Cuvantul “Continut” include, cu titlul de exemplu , orice text, imagini, desene, combinatii de
                            culori, arhive
                            audio sau video, software, marci inregistrate, logo-uri, slogane si desene industriale, coduri
                            ale fondului
                            literelor, interfata si structura, design, selectia si ordonarea sau prezentarea oricaror
                            informatii incluse
                            in site-ul web.</p>
                        <p>Orice incercare neuatorizata de a modifica sau utiliza materialele incluse in site, de a forta
                            elementele de
                            securitate sau de a folosi site-ul sau parte din continut ori material incluse in continut cu
                            alt scop decat
                            cel pentru&nbsp; care a fost construit site-ul, este strict interzisa.</p>
                        <p>Utilizarea acestor materiale sau continut se face pe propria raspundere. Danone isi rezerva
                            dreptul de a
                            modifica orice parte sau intreg continutul materialelor, software-ului, aplicatiilor si oricarui
                            alt element
                            utilizat sau inclus in site in orice moment, fara a notifica.</p>
                        <p>Danone nu va fi responsabil in nici un caz de nicio incalcare a drepturilor de proprietate
                            intelectuala
                            cauzat de continutul furnizat de terte parti. In plus, Danone nu va fi raspunzator de nici un
                            fel de daune
                            cauzate unor persoane sau proprietati, datorita metodelor, teoriilor, ideilor, opiniilor,
                            declaratiilor sau
                            recomandarilor exprimate in acest continut.</p>
                        <p>Prin exceptie la cele descrise inainte, acei care se considera lezati in drepturile lor de
                            proprietate
                            intelectuala de continutul acestui site, pot&nbsp;<a href="http://www.danone.ro/contact/">contacta
                                Danone</a>.</p>
                        <h3>POLITICA DE PROTECTIE A DATELOR PERSONALE</h3>
                        <p>Politica noastra de protectie a datelor personale, care poate fi accesata&nbsp;<a
                            href="http://www.danone.ro/wp-content/uploads/2014/04/Politica-de-protectie-a-datelor-personale.pdf">aici&nbsp;</a>si
                            este incorporata in aceste conditii de utilizare ca referinta, urmand cat in continuare sa
                            descriem
                            colectarea si utilizarea informatiei&nbsp; in cadrul acestui site.</p>
                        <h3>LEGATURI CATRE ALTE SITE-URI SI CONTINUT</h3>
                        <p>Site-ul web poate contine legaturi catre alte site-uri web administrate de alte companii. Danone
                            nu
                            monitorizeaza, nu promoveaza si nici nu are control asupra acestor site-uri.</p>
                        <p>Danone nu este raspunzator pentru continutul sau politicile tertilor carora le apartin acestor
                            site-uri si
                            intelegeti cat accesarea acestor site-uri se face pe propria raspundere.</p>
                        <p>Sunteti de acord ca Danone nu va fi raspunzator fata de dvs. sau fata de oricine altcineva pentru
                            niciun fel
                            de pierdere sau dauna, indiferent daca este bazata pe un contract sau nu, neglijenta, greseala
                            cu intentie
                            sau&nbsp;raspundere fara culpa pentru orice costuri, pierderi or prejudicii (directe, indirecte,
                            compensatorii, special, pierderea profitului, daune compensatorii, moratorii sau
                            penalitati)&nbsp;izvorand
                            sau in legatura cu accesul dvs. sau utilizarea de catre dvs. a site-ului tertei parti. In mod
                            special, in
                            conformitate cu cele prevazute mai sus, Danone nu este responsabil pentru:</p>
                        <ul>
                            <li>Disfunctii, lipsa de accesibilitate,&nbsp; de disponibilitate sau de continuitate;</li>
                            <li>Intretinere, continut, informatii, date, arhive, produse sau orice alta forma de
                                intretinere;
                            </li>
                            <li>Transmiterea sau prestarea de servicii, continut, informatii, date, file, produse si orice
                                alt
                                material;
                            </li>
                            <li>Calitatea, legalitatea, credibilitatea si utilitatea serviciilor, continutului, informatiei,
                                date, file,
                                produse si orice alt material;
                            </li>
                            <li>Virusuri sau orice element care dauneaza derivand din aceste terte site-uri, care pot altera
                                sistemul
                                computerului (partea hardware sau partea software) sau orice documente in format electronic
                                stocate in
                                ele.
                            </li>
                        </ul>
                        <p>Danone nu ofera si nu vinde direct sau prin intermediul unor terte parti, produsele si serviciile
                            disponibile
                            in site-urile apartinand unor terte parti.</p>
                        <p>Danone avertizeaza ca nu controleaza, monitorizeaza si nu sustine produsele, serviciile,
                            continutul,
                            informatiile, datele, filele, produse si orice alt material din site-urile tertelor parti. De
                            aceea, Danone
                            recomanda utilizatorului sa fie prudent in utilizarea serviciilor, informatiilor, datelor,
                            filelor,
                            produselor si oricarui fel de material ale unor terte parti.</p>
                        <p>In plus, Utilizatorul si in general, celor care intentioneaza sa creeze link-uri catre propriile
                            lor site-uri
                            (denumite site-uri straine), vor respecta urmatoarele conditii:</p>
                        <ul>
                            <li>Este interzisa crearea unui browser sau mediu inconjurator in cadrul acestui site;</li>
                            <li>Este interzis sa includeti informatii false, nereale sau incorecte despre acest site sau
                                continutul sau
                                si, in particular, este interzis sa declarati sau lasati sa se subinteleaga ca Danone a
                                autorizat
                                linkul, a&nbsp; supervizat sau a permis continutul sau serviciie oferite sau disponibile
                                catre altii pe
                                site-ul web la care face trimitere legatura.
                            </li>
                            <li>Cu exceptia&nbsp; simbolurilor care sunt parte a linkului, site-ul web catre care se face
                                trimitere nu
                                poate contine marci inregistrate, etichete, nume, logouri, sloganuri sau alte
                            </li>
                            <li>Este interzis ca site-ul catre care se face legatura sa contina informatii ilegale, contrare
                                morale, sau
                                infomatii care incalca drepturile unei terte parti.
                            </li>
                            <li>Utilizarea unor nume de branduri, nume de comert, semen, sloganuri, nume sau alte semne
                                distinctive
                                apartinand Danone in cuvintele cheie ale tertelor parti, fara consimtamantul expres al
                                Danone.
                            </li>
                        </ul>
                        <p>Stabilirea unui link la acest site web de catre o terta parte nu implica in nici un caz existenta
                            unor
                            relatii intre Danone si proprietarul acestui site web al unei terte parti ori acceptarea sau
                            aprobarea de
                            catre Danone a continutului sau serviciilor, in alte conditii decat cele expuse de Danone.</p>
                        <h3>LIMITAREA RASPUNDERII SI INLATURAREA RASPUNDERII</h3>
                        <p>ACEST SITE WEB SI CONTINUTUL SAU SUNT OFERITE “ASA CUM SUNT”, FARA GARANTII DE NICI UN FEL,
                            EXPRESE SAU
                            IMPLICITE, FARA GARANTII CU PRIVIRE LA TITLU, SAU DE VANDABILITATE, FARA A FI POTRIVITE UNUI
                            SCOP ANUME SI
                            FARA A REALIZA VREO INCALCARE A DREPTURILOR DE PROPRIETATE INTELECTUALA.</p>
                        <p>ACEST SITE WEB POATE CONTINE ERORI DE REDACTARE SI ALTE CATEGORII DE ERORI SI DVS. SUNTETI DE
                            ACORD CA NU
                            SUNTEM RASPUNZATORI DE ACESTE ERORI. DANONE NU GARANTEAZA SI NU SUSTINE CA ACEST SITE ESTE
                            LIPSIT DE ERORI,&nbsp;CA
                            ACCESUL VA FI NEINTRERUPT SAU CA SITE-UL ori SERVERUL PE CARE ESTE INSTALAT ESTE DISPONIBIL,
                            FARA VIRUSI SAU
                            FARA ALTE COMPONENTE CARE POT PRODUCE DAUNE.</p>
                        <p>DANONE MENTIONEAZA IN MOD EXPRES CA NU ARE OBLIGATIA DE A ADUCE LA ZI, REVIZUI MATERIALELE DE PE
                            SITE, &nbsp;CU
                            TOATE CA DANONE POATE MODIFICA&nbsp; MATERIALELE DE PE WEBSITE IN ORICE MOMENT FARA NOTIFICARE.
                            UTILIZAREA
                            SITE-ULUI WEB SE FACE PE PROPRIA RASPUNDERE SI VA ASUMATI RASPUNDEREA PENTRU ORICE COSTURI
                            ASOCIATE
                            UTILIZARII SITE-ULUI, DACA NU ESTE GENERAT DE DANONE.</p>
                        <p>DANONE NU VA FI RASPUNZATOR PENTRU UTILIZAREA SITE-ULUI, INCLUSIV CU PRIVIRE LA CONTINUT SAU
                            ORICE ERORI
                            CONTINUTE IN CADRUL SAU ORI PROVENIND DE LA TERTE PARTI. IN NICI UN CAZ DANONE NU VA FI
                            RASPUNZATOR PENTRU
                            CULPA, RASPUNDERE CONTRACTUALA, RASPUNDERE SPECIALA &nbsp;SAU ALTA TEORIE LEGALA SAU PRINCIPIU
                            ECHITABIL
                            PENTRU ORICE PIERDERE DIRECTA, SPECIALA, INCIDENTALA, OR DAUNE CONSECVENTIALE, PIERDERE DE
                            PROFIT, PIERDERE
                            DE DATE, PIERDERE DE OPORTUNITATI, COSTURI DIRECTE, PENALITATI, VATAMARE CORPORALA, ACCIDENT
                            MORTAL, FIECARE
                            DINTRE ACESTEA ESTE EXCLUS PRIN INTELEGEREA PARTILOR, INDIFERENT DACA DANONE A FOST NOTIFICAT
                            DESPRE ACEST
                            PREJUDICIU, DACA NU ESTE CAUZAT DE DANONE.</p>
                        <h3>COMPENSARE</h3>
                        <p>Sunteti de acord sa compensati compania Danone, compania-mama si companiile afiliate si pe
                            oricare dintre
                            functionarii Danone, directori, angajati, reprezentanti sau agenti impotriva oricaror cereri,
                            reclamatii,
                            pierderi, raspunderi, daune (inclusiv onorariile avocatilor si costurile instantei) generate de
                            (i)
                            utilizarea de catre&nbsp; dvs. a site-ului si (ii) incalcarea sau pretinsa incalcare de catre
                            dvs. a acestor
                            conditii.</p>
                        <h3>RENUNTARE</h3>
                        <p>Chiar daca Danone nu isi exercita drepturile mentionate in aceste conditii in intregime sau
                            partial, aceasta
                            nu inseamna ca in mod explicit sau implicit ca renunta la exercitarea lor, datorata unei
                            incalcari ale
                            conditiilor de catre utilizator. Drepturile si remediile vor fi cumulative si exercitiul unui
                            asemenea drept
                            sau remediu nu va limita exercitarea unui alt drept sau remediu. Daca vreo prevdere din
                            conditiile de
                            utilizare este nevalida sau neaplicabila n baza unui statut, regulament, ordonanta, ordin sau
                            lege, aceasta
                            prevedere se va interpreta prin prisma respectivului statut, sau oridn regulament, legi,
                            ordonanta iar ceea
                            ce este in conformitate cu acestea se va aplica.</p>
                        <h3>INFORMATII DE CONTACT</h3>
                        <p>Daca aveti intrebari, puteti sa ne contactati&nbsp;<a
                            href="http://www.danone.ro/contact/">aici</a>.</p>
                        <h3>DATA INTRARII IN VIGOARE</h3>
                        <p>Aceste conditii au fost actualizate pe 1 noiembrie 2019.</p>
                        <p><strong>Acest site foloseste tehnologie de profilare anonima a traficului</strong></p>
                        <p>Pentru a imbunatati experienta utilizatorilor sai, acest website foloseste tehnologia Avandor de
                            profilare
                            anonima a traficului web. In acest fel, interactiunile dvs de pe unele site-uri sunt colectate
                            si analizate
                            construindu-se un portret robot anonim ce poate fi utilizat la personalizarea mesajelor si
                            reclamelor pe
                            care le vedeti online.</p>
                        <p>Sistemul este 100% anonim si nu contine nici o informatie care va poate identifica personal.
                            Aflati mai multe
                            despre cum functioneaza Avandor, utilizarea de cookies, drepturile si posibilitatile dvs. de
                            opt-out la
                            acest&nbsp;<a href="http://profiling.avandor.com/privacy">link</a>.</p>

                        <p>&nbsp;</p>
                    </div>

                    <div className="bottom-content">

                    </div>

                </div>
            </div>
        </Typography>
    </Grid>

}

export default PageTermeniSiConditii;
